import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Translators } from 'src/app/services/shared/translators.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import Swal from 'sweetalert2';
import { GuiToolsService } from 'src/app/services/shared/gui-tools.service';
import { SolicitudesService } from '@services/ofertas-laborales/solicitudes.service';
import { StorageService } from '@services/shared/storage.service';
import { DetectarDispositivoService } from '@services/detectar-dispositivo/detectar-dispositivo.service';
import { OpenPageService } from '@services/shared/open-page.service';

@Component({
    selector: 'app-gym-coaching-banner',
    templateUrl: './gym-coaching-banner.component.html',
    styleUrls: ['./gym-coaching-banner.component.scss']
})
export class GymCoachingBannerComponent implements OnInit {

    showOverlay: boolean = false;
    showEmailPanel: boolean = false;
    email: string = '';

    idioma: Subscription;

    showSpinner: boolean = false;
    spinnerMessage: string = '';

    showStatusMessage: boolean = false;
    statusMessage: string = '';

    // URLs de descarga
    private readonly URL_IOS = 'https://apps.apple.com/ar/app/signo-medico-osoetsylra/id6747086964';
    private readonly URL_ANDROID = 'https://play.google.com/store/apps/details?id=io.cipbyte.signomedico&pcampaignid=web_share';

    constructor(
        private translatorService: Translators,
        private router: Router,
        private authservice: AuthService,
        private guiToolsService: GuiToolsService,
        private solicitudesService: SolicitudesService,
        private storageService: StorageService,
        private dispositivoService: DetectarDispositivoService,
        private openPageService: OpenPageService
    ) {}

    ngOnInit(): void {}

    useLanguage(idioma: string){
        this.translatorService.setIdiomaSeleccionado(idioma);
    }

    navigateRoot(url: string){
        this.router.navigateByUrl(url);
    }

    getGuestToken() {
        Swal.showLoading()
        this.authservice.getGuestToken();
    }

    openOverlay(): void {
        this.showOverlay = true;
      }
    
    closeOverlay(): void {
        this.showOverlay = false;
    }
    
    redirectToApp(): void {
        // Primero verificamos si es dispositivo móvil
        const esMovil = this.dispositivoService.isAndroid() || this.dispositivoService.isIOS();
        
        if (!esMovil) {
            // Dispositivo no móvil (escritorio) - redirige a Android
            window.location.href = this.URL_ANDROID;
        } else {
            // Dispositivo móvil - detectamos específicamente
            if (this.dispositivoService.isAndroid()) {
                window.location.href = this.URL_ANDROID;
            } else if (this.dispositivoService.isIOS()) {
                window.location.href = this.URL_IOS;
            } else {
                // Por si acaso, cualquier otro móvil va a Android
                window.location.href = this.URL_ANDROID;
            }
        }
    }

    verificarInscripcion() {
        this.showEmailPanel = true;
    }

    volverAlLogin() {
        this.showEmailPanel = false;
        this.showSpinner = false;
        this.email = '';
        this.showStatusMessage = false;
    }

    async verificarEmail() {
        if (!this.email) {
            console.log('Error: Email vacío');
            return;
        }

        try {
            console.log('Iniciando verificación de email:', this.email);
            
            const fechaDesde = new Date('2025-06-01');
            const fechaHasta = new Date();
            fechaHasta.setFullYear(fechaHasta.getFullYear() + 1);

            const sede = {
                signoSedes: ["689e41b9bf64830c3ec6a613"]
            };

            const fecha = {
                fechaDesde: fechaDesde.toISOString().split('T')[0],
                fechaHasta: fechaHasta.toISOString().split('T')[0]
            };

            console.log('Parámetros de búsqueda:', { sede, fecha, email: this.email });

            const solicitudes: any[] = await this.solicitudesService.getSolicitudesBySedeEncrypted(
                sede, 
                fecha, 
                this.email.toLowerCase()
            );
            
            console.log('Solicitudes obtenidas (ya filtradas por email):', solicitudes);

            if (solicitudes && solicitudes.length > 0) {
                const solicitudEncontrada = solicitudes[0];
                const estados = solicitudEncontrada.states;
                const estado = estados[estados.length - 1]?.numberState;
                
                console.log('✅ Solicitud encontrada - Estado:', estado);
                
                // CASO B: Estado 14 - Redirigir a DDJJ con datos precargados
                if (estado === 14) {
                    console.log('🎯 Estado 14: Redirigiendo a DDJJ con datos existentes');
                    
                    // Mostrar spinner
                    this.showSpinner = true;
                    this.spinnerMessage = 'Preparando el formulario de su declaración jurada';
                    
                    // Replicar EXACTAMENTE la estructura de inscripcion-os
                    const datosParaDDJJ = {
                        inscripcion: solicitudEncontrada.inscripcion?.contenido,
                        usuario: solicitudEncontrada.usuario,
                        solicitudId: solicitudEncontrada._id
                    };
                    
                    console.log('💾 Estructura de datos para DDJJ:', datosParaDDJJ);
                    
                    // Guardar en localStorage
                    await this.storageService.setInscripcionOsData(datosParaDDJJ);
                    console.log('💾 Datos guardados exitosamente en localStorage');
                    
                    // Timeout de 4 segundos antes de redirigir
                    setTimeout(() => {
                        this.router.navigate(['/inscripcion-os'], { queryParams: { phase: 'ddjj' } });
                    }, 4000);
                    return;
                }
                
                // CASO C: Estado 15 - Pendiente de revisión
                if (estado === 15) {
                    console.log('⏳ Estado 15: Mostrando mensaje de revisión');
                    this.showStatusMessage = true;
                    this.statusMessage = 'Su solicitud de afiliación se encuentra en proceso de revisión. Le notificaremos por correo electrónico una vez que sea aprobada.';
                    return;
                }

                // CASO D: Estado 16 - Completa  
                if (estado === 16) {
                    console.log('✅ Estado 16: Mostrando mensaje de aprobación');
                    this.showStatusMessage = true;
                    this.statusMessage = 'Su solicitud de afiliación ha sido aprobada. Por favor, revise su correo electrónico para obtener más información sobre los próximos pasos.';
                    return;
                }
                
            } else {
                // CASO A: No existe solicitud - Redirigir a inscripción
                console.log('❌ No se encontró solicitud para el email:', this.email);
                
                // Mostrar spinner
                this.showSpinner = true;
                this.spinnerMessage = 'Cargando formulario de afiliación';
                
                // Guardar email para precargar en inscripcion-os
                localStorage.setItem('emailInscripcion', this.email);
                console.log('📝 Email guardado en localStorage');
                
                // Timeout de 4 segundos antes de redirigir
                setTimeout(() => {
                    this.router.navigate(['/inscripcion-os']);
                }, 4000);
            }

        } catch (error) {
            console.error('❌ Error al verificar email:', error);
            this.showSpinner = false;
        }
    }

    openBlank(type: string) {
        this.openPageService.openBlank(type);
    }
}